// extracted by mini-css-extract-plugin
export default {"gamesSortContainer":"GamesSort_gamesSortContainer__pzzce","gamesSortInput":"GamesSort_gamesSortInput__6INOL"};